import {
  useMemo,
  useState,
} from 'react';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import useChargebee from './useChargebee';

const useChargebeeCheckoutHostedPage = (business: BusinessModel) => {
  const [error, setError] = useState();
  const chargebeeInstance = useChargebee();

  const openCheckout = useMemo(
    () => {
      return (chargebeeCallbacks = {}) => {
        if (!chargebeeInstance) return null;
        // @ts-ignore
        chargebeeInstance.closeAll(); // Ensure we don't try to open multiple at the same time
        setError(undefined);
        // @ts-ignore Look, just trust me, ok?
        return chargebeeInstance.openCheckout({
          hostedPage: () => Promise.resolve(business.hostedPageUrl),
          layout: 'in_app',
          error: setError,
          ...chargebeeCallbacks,
        });
      };
    },
    [business, chargebeeInstance],
  );

  return [openCheckout, chargebeeInstance, error];
};

export default useChargebeeCheckoutHostedPage;
